import { CommApiInstance } from "Utils/CommApiInstance";

const MembOtpUnRegApi = async (
) => {
    return await CommApiInstance.post(`memb/otp/unreg`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default MembOtpUnRegApi;